import React from "react";
import PropTypes from "prop-types";

import Select from "../../../common/controls/Select";
import Label from "../../../common/controls/Label";

export default class SearchStereotypeSelection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedStereotype: props.options[0].value, // always select the first item
        };
        this.onCommitChange = this.onCommitChange.bind(this);
    }

    onCommitChange(value) {
        const {onChange} = this.props;
        this.setState({selectedStereotype: value});
        onChange(value);
    }

    render() {
        const { options } = this.props;
        if (options.length === 1) {
            const activeLabel = options[0].label;
            return (<Label id="source-type" label="Search by:" value={activeLabel} controlOnly={false} />);
        } else {
            return (<Select id="source-type" label="Search by:" onCommitChange={this.onCommitChange} options={options} value={this.state.selectedStereotype} controlOnly={false} />);
        }
    }

}

SearchStereotypeSelection.propTypes = {
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired
};



// WEBPACK FOOTER //
// ./app/lib/mapping/views/recordsourcepluginview/SearchStereotypeSelection.js